import {
  NumberInputProps,
  NumberInput as MantineNumberInput,
  createStyles,
} from '@mantine/core';
import { forwardRef, memo } from 'react';

import { useInputStyles } from './TextInput/styles';

type NumberInputType = React.ForwardRefExoticComponent<
  NumberInputProps & React.RefAttributes<HTMLInputElement>
>;

const useNumberStyles = createStyles(() => {
  return {
    root: {
      width: '100%',
    },
  };
});
function NumberInput(
  props: NumberInputProps,
  ref: React.Ref<HTMLInputElement>,
) {
  const { classNames, rightSectionWidth, iconWidth, ...rest } = props;
  const { root, ...otherNames } = classNames || {};
  const { classes: inputClasses } = useNumberStyles(undefined, {
    classNames: { root },
    name: 'NumberInput',
  });
  const { classes } = useInputStyles(
    { rightSectionWidth, iconWidth },
    {
      classNames: { ...inputClasses, ...otherNames },
      name: 'NumberInput',
    },
  );

  return <MantineNumberInput classNames={classes} ref={ref} {...rest} />;
}
export default memo(
  forwardRef<HTMLInputElement, NumberInputProps>(NumberInput),
) as NumberInputType;
